export default {
      id: "ellipsis-usage",
      viewBox: "0 0 18.266 4.566",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#ellipsis-usage",
      toString: function () {
        return this.url;
      }
    }